import React, { FC, useState } from 'react'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import Button from 'UI/Button/Button'
import { _source } from 'utils/csvConfig'
import { getUrlPageValues } from '../../containers/VerticalPage/common/utils'
import { onCSVExport } from 'utils/verticals'
import useMessage from '../../hooks/useCustomMessage'
import { useCurrency } from 'contexts'

const exportIconUrl = require('../../icons/export.svg')

interface IExportCSVTableVertical {
  zoneIndex: string
  csvFileName: string
  searchValue: string
  selectedIds?: string[]
  sorting?: {
    desc: boolean
    id: string
  }[]
  total?: number
}

const ExportCSVTableVertical: FC<IExportCSVTableVertical> = ({
  zoneIndex,
  csvFileName,
  searchValue,
  selectedIds,
  sorting,
  total,
}) => {
  const { trackEvent } = useMatomo()
  const { openMessage, contextHolder } = useMessage()
  const { currentCurrency, exchangeRates, isLoadingExchangeRates } = useCurrency()

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const isDisabled = !total || total === 0 || isLoadingExchangeRates

  const onExportClick = () => {
    setIsLoading(true)

    const currencyContext = {
      currencyConversion: currentCurrency !== 'USD',
      currentCurrency,
      exchangeRates: exchangeRates?.[`${currentCurrency}_all_yearly`] || null,
    }

    onCSVExport(
      zoneIndex,
      _source,
      getUrlPageValues()[0],
      csvFileName,
      searchValue,
      trackEvent,
      selectedIds,
      sorting,
      currencyContext,
    )
      .then(() => openMessage('success', 'File successfully exported'))
      .catch(() => openMessage('error', 'File export failed , please try again later'))
      .finally(() => setIsLoading(false))
  }

  return (
    <>
      {contextHolder}
      <Button
        loading={isLoading}
        buttonType='primary'
        icon={<img src={exportIconUrl} alt='Export' />}
        onClick={onExportClick}
        disabled={isDisabled}
      >
        Export
      </Button>
    </>
  )
}

export default ExportCSVTableVertical
